module.exports = __webpack_public_path__ + "img/cb833ba.jpg";